import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Layer, Rect, Group, RegularPolygon, Circle } from 'react-konva';
import ChamberRowView from './chamber-row';
import ChamberRowClass from '../../lib/chamber-row';
import Manifold from './manifold';
import {
  CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER_ROW,
  CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER_BED,
  GLOBAL_DRAWING_SELECTOR_MODE_DIRECT,
} from '../../lib/types';

import Konva from 'konva';
import {
  chamberBedMoved,
  chamberBedTransformed,
  chamberRowsRebuild,
  chamberBedContextSelected,
  chamberBedSetCentralizedCoordinates,
  restoredStateBedRendered,
  updateNumberOfFeedConnectors,
  updatePositionOfInspectionPort,
} from '../../actions/chamber-bed-actions';
import { getScaledValue } from '../../actions/calculations-actions';
import Underdrain from './underdrain';
import ManifoldSelectors from '../../reducers/main-manifold-reducer';
import {
  cleanChambersByManifoldMainRowArray,
  cleanChambersByManifoldVoidArray,
  getChamberAccessoryMap,
} from '../../actions/chamber-actions';
import { setUpdatePerimeterOnBed } from '../../actions/multi-bed-actions';
import { computeStoneBed, setChamberAccesory } from '../../actions/floating-tool-actions';
import { shouldChamberPlaceFeedConnector, getInspectorPortPos } from '../../lib/misc/misc_utils';

class ChamberBed extends PureComponent {
  state = {
    tfmr: null,
    dimensionsComputed: false,
    addFeedConnectorArray: [],
    removeFeedConnectorArray: [],
    inspectionPortPos: null,
  };

  componentDidMount() {
    this.buildChamberRows(this.props, this.props);
    this.handleOnTransformEnd(true);
  }

  componentDidUpdate(prevProps, prevState) {
    // Cleans metadata from chambers when bed is resized.
    if (this.props.numOfRows !== prevProps.numOfRows || this.props.numOfChambers !== prevProps.numOfChambers) {
      setTimeout(() => {
        const existingManifoldsIds = this.props.mainManifolds.map((manifold) => {
          return manifold._id;
        });
        const manifoldsOnChambersArray = [];
        this.props.chamberRows.forEach((rows) => {
          rows._chambers.forEach((chambers) => {
            if (chambers._isManifoldConnectedArray.length > 0) {
              manifoldsOnChambersArray.push(...chambers._isManifoldConnectedArray);
            }
          });
        });
        const uniqIds = [...new Set(manifoldsOnChambersArray)];

        if (uniqIds.length > 0) {
          const clean = uniqIds.filter((el) => existingManifoldsIds.indexOf(el) < 0);
          clean.forEach((id) => {
            this.props.cleanChambersByManifoldVoidArray(id, 0, 0);
            this.props.cleanChambersByManifoldMainRowArray(id, 0, 0);
          });
        }
      });
    }

    // the properties to be checked
    let names = [
      'scaleX',
      'scaleY',
      'scalePixels',
      'scaleValue',
      'chamberType',
      'chamberRowSpacing',
      'numOfRows',
      'numOfChambers',
    ];

    // if scales changed, rebuild chamber rows
    if (this.anyPropHasChanged(prevProps, names)) {
      this.buildChamberRows(prevProps, this.props);
      if (this.props.isRestoringState) {
        this.buildChamberRows(this.props, this.props);
      }
    }

    // if scale value and scale pixels have changed
    if (this.anyPropHasChanged(prevProps, ['scalePixels', 'scaleValue']) || this.props.isRestoringState) {
      this.handlePerimeterScaling(prevProps, this.props);
    }

    // if only the chamber type has changed
    if (this.anyPropHasChanged(prevProps, ['chamberType'])) {
      this.handlePerimeterScaling(prevProps, this.props);
      this.handleOnTransformEnd(true);
    }

    // if computed viewport dimensions have changed, reposition the chamber bed
    if (this.anyPropHasChanged(prevProps, ['computedHeight', 'computeWidth']) && !this.state.dimensionsComputed) {
      // when drag ends, set position into state
      this.props.chamberBedSetCentralizedCoordinates({
        x: this.props.computeWidth / 2 + (this.props.height * this.props.scaleX) / 2,
        y: this.props.computedHeight / 2 - (this.props.width * this.props.scaleY) / 2,
      });
      // do this only when viewport is set
      this.setState({
        dimensionsComputed: true,
      });
    }

    if (
      this.anyPropHasChanged(prevProps, ['drawingSelectorMode']) &&
      this.props.drawingSelectorMode === GLOBAL_DRAWING_SELECTOR_MODE_DIRECT
    ) {
      this.guaranteeUnmountedTransformer();
    }

    // guarantee the component is mounted if the stage changes
    if (this.anyPropHasChanged(prevProps, ['viewportPositionX', 'viewportPositionY'])) {
      this.guaranteeMountedTransformer();
    }

    if (this.props.isRestoringState) {
      this.props.restoredStateBedRendered();
    }

    if (this.props.updatePerimeterOnBed) {
      this.buildChamberRows(prevProps, this.props);
      if (this.props.isRestoringState) {
        this.buildChamberRows(this.props, this.props);
      }

      /* calculate the new scaling for the grey line*/
      let scaleY = this.calculatedBedWidth(this.props.numOfRows) / this.props.height;
      let scaleX = this.calculatedBedLength(this.props.numOfChambers) / this.props.width;

      this.props.chamberBedTransformed({
        scaleX: scaleX,
        scaleY: scaleY,
      });

      this.props.setUpdatePerimeterOnBed(false);
    }

    if (
      this.props['mainMainManifolds'].manifolds.length > 0 &&
      this.props['mainMainManifolds'].manifolds.length !== prevProps.mainMainManifolds.manifolds.length
    ) {
      //remove inspection-port if there is another to be added
      if (!!prevState.inspectionPortPos) {
        this.props.setChamberAccesory(prevState.inspectionPortPos.row, prevState.inspectionPortPos.col, null);
      }
      let {
        mapFeedConnectorChambers: addFeedConnectorArray,
        mapFeedConnectorIsolatorChambers: removeFeedConnectorArray,
      } = shouldChamberPlaceFeedConnector(this.props['chamberbed'], this.props['mainMainManifolds']);
      this.setState({
        addFeedConnectorArray: addFeedConnectorArray,
        removeFeedConnectorArray: removeFeedConnectorArray,
      });

      console.log(
        {
          addFeedConnectorArray,
          removeFeedConnectorArray,
        },
        addFeedConnectorArray.length,
        removeFeedConnectorArray.length,
      );

      this.props.updateNumberOfFeedConnectors({
        numberOfFeedConnectors: addFeedConnectorArray.length,
        numberOfRemovedFeedConnectors: removeFeedConnectorArray.length,
      });
      setTimeout(() => {
        this.setState({
          inspectionPortPos: getInspectorPortPos(this.props['chamberbed']),
        });
      });
    }

    const arraysAreEqual = (arr1, arr2) => {
      // Check if the arrays have the same length
      if (arr1.length !== arr2.length) {
        return false;
      }
      arr1.sort();
      arr2.sort();
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    };

    //Adding feed connectors
    if (
      this.state.addFeedConnectorArray.length > 0 &&
      !arraysAreEqual(this.state.addFeedConnectorArray, prevState.addFeedConnectorArray)
    ) {
      setTimeout(() => {
        for (const connectorMap of this.state.addFeedConnectorArray) {
          const chamberAccessory = this.getChamberAccessoryTee('Feed-connector');
          this.props.setChamberAccesory(connectorMap.row, connectorMap.col, chamberAccessory);
        }
      });
    }
    //Removing invalid feed connectors
    if (
      this.state.removeFeedConnectorArray.length > 0 &&
      !arraysAreEqual(this.state.removeFeedConnectorArray, prevState.removeFeedConnectorArray)
    ) {
      // add the feed connector
      for (const connectorMap of this.state.removeFeedConnectorArray) {
        this.props.setChamberAccesory(connectorMap.row, connectorMap.col, null);
      }
    }

    // add Inspection-port
    if (!!this.state.inspectionPortPos && this.state.inspectionPortPos !== prevState.inspectionPortPos) {
      const chamberAccessory = this.getChamberAccessoryTee('Inspection-port');

      this.props.updatePositionOfInspectionPort({
        row: this.state.inspectionPortPos.row,
        col: this.state.inspectionPortPos.col,
      });

      setTimeout(() => {
        this.props.setChamberAccesory(
          this.state.inspectionPortPos.row,
          this.state.inspectionPortPos.col,
          chamberAccessory,
        );
      });
    }
  }

  computeSeparationDistance(separation) {
    return this.props.scalePixels * (separation / 12 / this.props.scaleValue);
  }

  getChamberAccessoryTee(id) {
    return this.props.getChamberAccessoryMap().get(id);
  }

  /*----------------------- CAREFUL WITH THIS SECTION -----------------------*/

  /* NOTE(IMPORTANT): Here we need to translate the real chamber components dimensions to drawing 2D
    dimensions.
    - The chamber's width(how wide is the chamber) is the 2D height* of the drawing image.
    - The chamber's length(how long is the chamber) is the 2D width* of the drawing image.
    */
  getChamberHeight() {
    return this.props.scalePixels * (this.props.chamberType.width / this.props.scaleValue);
  }

  getChamberWidth() {
    return this.props.scalePixels * (this.props.chamberType.length / this.props.scaleValue);
  }

  getScaledValue(value) {
    return this.props.scalePixels * (value / this.props.scaleValue);
  }

  getChamberInstalledOffset() {
    let width = this.getChamberWidth();
    let installedWidth = this.props.scalePixels * (this.props.chamberType.installedLength / this.props.scaleValue);

    return width - installedWidth;
  }

  getEndCapHeight() {
    return this.props.scalePixels * (this.props.chamberEndCapType.width / this.props.scaleValue);
  }

  getEndCapWidth() {
    return this.props.scalePixels * (this.props.chamberEndCapType.length / this.props.scaleValue);
  }

  getEndcapInstalledOffset() {
    let width = this.getEndCapWidth();
    let installedWidth =
      this.props.scalePixels * (this.props.chamberEndCapType.installedLength / this.props.scaleValue);

    return width - installedWidth;
  }

  getRowSpacing() {
    return this.props.scalePixels * (this.props.chamberRowSpacing / this.props.scaleValue);
  }

  calculatedBedLength(numOfChambers) {
    let chamberWidth = this.getChamberWidth();
    let chamberInstalledOffset = this.getChamberInstalledOffset();
    let endCapWidth = this.getEndCapWidth();
    let endcapInstalledOffset = this.getEndcapInstalledOffset();

    return (
      chamberWidth * numOfChambers -
      chamberInstalledOffset * (numOfChambers - 1) +
      (endCapWidth - endcapInstalledOffset) * 2
    );
  }

  calculatedBedWidth(numOfRows) {
    let chamberHeight = this.getChamberHeight();
    let rowSpacing = this.getRowSpacing();

    return numOfRows * chamberHeight + rowSpacing * (numOfRows - 1);
  }

  /**
   * This method receives the previous properties object and an Array of
   * the properties to be determined if have changed and returns true if any
   * have changed, or false if all are the same.
   *
   * @param {Object} prevProps The previous properties of the component.
   * @param {Array<string>} propNames The Properties names array.
   */
  anyPropHasChanged(prevProps, propNames) {
    let changed = false;
    for (let name of propNames) {
      changed = this.props[name] !== prevProps[name] || changed;
    }
    return changed;
  }

  buildChamberRows(prevProps, currentProps) {
    /* if chamber type is not present, return empty array */
    if (!this.props.chamberType || !this.props.chamberEndCapType) {
      return;
    }
    /* get all element dimensions */
    let chamberHeight = this.getChamberHeight();
    let chamberWidth = this.getChamberWidth();
    let chamberInstalledOffset = this.getChamberInstalledOffset();
    /* the endcap calculations */
    /* NOTE: here we decided to set the width of the endcap the same as the chamber
    because of rotation issues in iLogic side */
    let endCapHeight = this.getChamberHeight(); //this.getEndCapHeight();
    let endCapWidth = this.getEndCapWidth();
    let endcapInstalledOffset = this.getEndcapInstalledOffset();
    /*----------------------- CAREFULLY WITH THIS SECTION -----------------------*/
    /* calculating the row spacing */
    let rowSpacing = this.getRowSpacing();
    /* Calculate number of rows fitting in drawing rectangle  and number of chambers per row*/
    let numOfRows = this.props.numOfRows;
    let numOfChambers = this.props.numOfChambers;

    /* calculated row length and bed width */
    let calculatedBedLength = this.calculatedBedLength(numOfChambers);

    /* detect scaling changes in order to align chamber matrix */
    let scalingDiff = currentProps.scaleY * currentProps.height - prevProps.scaleY * prevProps.height;
    let rowChange = Math.floor(Math.round(scalingDiff / (chamberHeight + rowSpacing)));
    let scaledFromRight =
      Math.abs(parseInt(prevProps.x, 10) - parseInt(currentProps.x, 10)) > 5 ||
      Math.abs(parseInt(prevProps.y, 10) - parseInt(currentProps.y, 10)) > 5;

    /* determine if extending from right or not */
    rowChange = scaledFromRight ? rowChange : 0;
    if (this.props.isRestoringState && prevProps.numOfRows === currentProps.numOfRows) {
      rowChange = 0;
    }
    let columnChange = 0;

    /* align chamber rows, i.e. copy state from previous */
    let oldRows;

    if (rowChange !== 0 || this.props.isRestoringState) {
      oldRows = this.alignChamberBedMatrix(currentProps.chamberRows, columnChange, rowChange);
    } else {
      oldRows = currentProps.chamberRows;
    }
    // the new rows array
    let chamberRows = [];
    // build chamber rows
    for (let i = 0; i < numOfRows; i++) {
      let rowInstance;
      // create a new row instance
      if (oldRows[i]) {
        rowInstance = oldRows[i].clone();
      } else {
        rowInstance = new ChamberRowClass();
      }
      // set all properties
      rowInstance.row = i;
      rowInstance.x = 0;
      // add y offset depending if there is row spacing in between
      rowInstance.y = i * (chamberHeight + (i > 0 && i < numOfRows ? rowSpacing : 0));
      rowInstance.height = chamberHeight;
      rowInstance.width = calculatedBedLength;
      rowInstance.endCapHeight = endCapHeight;
      rowInstance.endCapWidth = endCapWidth;
      rowInstance.endcapInstalledOffset = endcapInstalledOffset;
      rowInstance.chamberWidth = chamberWidth;
      rowInstance.chamberInstalledOffset = chamberInstalledOffset;
      // recalculate row dimensions to finalize
      rowInstance.resizeDimensions();
      // add row to collection
      chamberRows.push(rowInstance);
    }

    this.props.chamberRowsRebuild(chamberRows, numOfRows, numOfChambers);
  }

  alignChamberBedMatrix(currentRows, columnChange, rowChange) {
    /* log the top an right differences */
    // console.log("Top Difference: ", columnChange);
    // console.log("Right Difference: ", rowChange);
    /* align matrix's before rebuilding */
    let rows = currentRows.slice();
    /* remove or add rows */
    if (rowChange > 0 && rows.length !== this.props.numOfRows) {
      rows.unshift(...Array(rowChange).fill(null));
    } else if (rowChange < 0) {
      rows = rows.slice(-rowChange);
    }
    /* reindex rows */
    rows = rows.map((r, i) => {
      if (r) {
        r.reindex(i);
      } else {
        r = new ChamberRowClass();
      }
      return r;
    });
    /* return the aligned matrix */
    return rows;
  }

  handleBedOnclick() {
    if (this.props.drawingSelectorMode === GLOBAL_DRAWING_SELECTOR_MODE_DIRECT) {
      this.props.chamberBedContextSelected();
    } else {
      this.mountOrUnmountTransformer();
    }
  }

  mountOrUnmountTransformer() {
    /* destroy if transformers exist */
    if (this.state.tfmr) {
      this.state.tfmr.destroy();
      this.setState({ tfmr: null });
    } else {
      this.mountTransformer();
    }
  }

  guaranteeMountedTransformer() {
    if (this.state.tfmr) {
      this.state.tfmr.destroy();
      this.mountTransformer();
    }
  }

  guaranteeUnmountedTransformer() {
    if (this.state.tfmr) {
      this.state.tfmr.destroy();
      this.setState({ tfmr: null });
    }
  }

  mountTransformer() {
    /* get layer references */
    let layer = this.borderNode.getLayer();
    /* create transformer */
    let tfmr = new Konva.Transformer();
    /* CULTEC bed transformers disable resize*/
    tfmr.resizeEnabled(false);
    layer.add(tfmr);
    tfmr.attachTo(this.borderNode);
    layer.batchDraw();
    /* set transformer state */
    this.setState({ tfmr: tfmr });
  }

  handleOnMouseEnter() {
    if (this.props.drawingSelectorMode === GLOBAL_DRAWING_SELECTOR_MODE_DIRECT && !this.props.isPanning) {
      this.frontArrowNode.getStage().container().style.cursor = 'default';
    } else if (!this.props.isPanning) {
      this.frontArrowNode.getStage().container().style.cursor = 'move';
    }
  }

  handleOnMouseLeave() {
    if (!this.props.isPanning) {
      this.frontArrowNode.getStage().container().style.cursor = 'default';
    }
  }

  handlePerimeterScaling(prevProps, currentProps) {
    let scalingRatio =
      currentProps.scalePixels / currentProps.scaleValue / (prevProps.scalePixels / prevProps.scaleValue);
    let scaleX = currentProps.scaleX * scalingRatio;
    let scaleY = currentProps.scaleY * scalingRatio;
    this.props.chamberBedTransformed({
      scaleX: scaleX,
      scaleY: scaleY,
    });
  }

  handleOnTransformEnd(manualTrigger) {
    /* adjust dimensions before invoking action in order to fit
    rectangular dotted line to content of chamber bed */
    /* get all element dimensions */
    let chamberHeight = this.getChamberHeight();
    let chamberWidth = this.getChamberWidth();
    // let chamberInstalledOffset = this.getChamberInstalledOffset();
    // let endCapWidth = this.getEndCapWidth();
    // let endcapInstalledOffset = this.getEndcapInstalledOffset();

    /* determine if the scaling is not big enough to continue with the transform,
    this prevents the bug of clicking the extend handlers that shrinks the bed
    does not matter if they are dragged */
    let heightChangeSignificant =
      Math.abs(this.borderNode.scaleX() - this.props.scaleX) * this.props.height >= chamberWidth / 10;

    let widthChangeSignificant =
      Math.abs(this.borderNode.scaleY() - this.props.scaleY) * this.props.width >= chamberHeight / 10;
    /* check if was rotated */
    let wasRotated = this.borderNode.rotation() !== this.props.rotation;
    let wasMoved = Math.abs(this.borderNode.x() - this.props.x) > 5;

    /* if change is not significant cancel transform */
    if (!wasMoved && !manualTrigger && !wasRotated && !heightChangeSignificant && !widthChangeSignificant) {
      this.borderNode.scaleY(this.props.scaleY);
      this.borderNode.scaleX(this.props.scaleX);
      return;
    }

    /*----------------------- CAREFUL WITH THIS SECTION -----------------------*/
    /* calculating the row spacing */
    // let rowSpacing = this.getRowSpacing();
    /* calculate new scaling, Dimensions are flipped because the front
    of the bed logic, the maximum width and height are the viewport(why I use Math.min) */
    let rectangleHeight = this.borderNode.scaleX() * this.props.width;
    let rectangleWidth = this.borderNode.scaleY() * this.props.height;
    // let rectangleWidth = Math.min(
    //   this.borderNode.scaleY() * this.props.height,
    //   Infinity,
    //   this.props.computeWidth - this.props.computeWidth * 0.02
    // );

    let newNumOfRows = 0;
    // let widthAccu = 0;
    /* check how many rows fits in the rectangle area */
    while (true) {
      if (Math.round(this.calculatedBedWidth(newNumOfRows)) <= Math.round(rectangleWidth)) {
        newNumOfRows++;
      } else {
        newNumOfRows--;
        break;
      }
    }

    let newNumOfChambers = 0;
    /* check how many rows fits in the rectangle area */
    while (true) {
      if (Math.round(this.calculatedBedLength(newNumOfChambers)) <= Math.round(rectangleHeight)) {
        newNumOfChambers++;
      } else {
        newNumOfChambers--;
        break;
      }
    }

    /* the new rectangle width and height */
    let newRectangleHeight = this.calculatedBedLength(newNumOfChambers);
    let newRectangleWidth = this.calculatedBedWidth(newNumOfRows);

    /* calculate the new scaling */
    let scaleY = newRectangleWidth / this.props.height;
    let scaleX = newRectangleHeight / this.props.width;

    /* when transformation ends, set position into state */
    if (wasRotated) {
      this.props.chamberBedTransformed({
        x: this.borderNode.x(),
        y: this.borderNode.y(),
        rotation: this.borderNode.rotation(),
      });
    } else {
      this.props.chamberBedTransformed({
        x: this.borderNode.x(),
        y: this.borderNode.y(),
        rotation: this.borderNode.rotation(),
        scaleX: scaleX,
        scaleY: scaleY,
        numOfRows: newNumOfRows,
        numOfChambers: newNumOfChambers,
      });
    }
  }

  handleFrontDragMove() {
    /* show borderline node moving */
    this.borderNode.x(this.frontGroupNode.x());
    this.borderNode.y(this.frontGroupNode.y());
    this.chamberGroupNode.x(this.frontGroupNode.x());
    this.chamberGroupNode.y(this.frontGroupNode.y());
    this.frontGroupNode.getLayer().batchDraw();
  }

  handleFrontDragEnd() {
    /* when drag ends, set position into state */
    this.props.chamberBedMoved({
      x: this.frontGroupNode.x(),
      y: this.frontGroupNode.y(),
    });
  }

  isContextSelected() {
    return (
      this.props.drawingSelectorMode === GLOBAL_DRAWING_SELECTOR_MODE_DIRECT &&
      this.props.contextSelectedElement &&
      this.props.contextSelectedElement.type === CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER_BED
    );
  }

  renderUpperManifolds() {
    return this.props.upperManifolds.map((manifold, idx) => {
      try {
        const { x, y, pixelOffSet } = this.props.chamberRows[manifold.initialRow],
          rowSpacing = this.getRowSpacing(),
          chamberWidth = this.getChamberWidth(),
          chamberHeight = this.getChamberHeight(),
          endcapWidth = this.getEndCapWidth(),
          endcapHeight = this.getEndCapHeight(),
          chamberInstalledOffset = this.getEndcapInstalledOffset(),
          endcapInstalledOffset = this.getEndcapInstalledOffset(),
          activeChamber = this.props.chamberRows[manifold.initialRow].chambers[manifold.letColumn];

        const realX = x + activeChamber.x + pixelOffSet - endcapWidth + endcapInstalledOffset,
          realY = y + activeChamber.y;
        return (
          <Group key={idx} x={realX} y={realY}>
            <Manifold
              x={0}
              y={0}
              manifold={manifold}
              chamberWidth={chamberWidth}
              chamberHeight={chamberHeight}
              endcapWidth={endcapWidth}
              endcapHeight={endcapHeight}
              chamberInstalledOffset={chamberInstalledOffset}
              endcapInstalledOffset={endcapInstalledOffset}
              rowSpacing={rowSpacing}
              chamberColumn={activeChamber.col}
            />
          </Group>
        );
      } catch (exception) {
        return null;
      }
    });
  }

  renderLowerManifolds() {
    return this.props.lowerManifolds.map((manifold, idx) => {
      try {
        const { x, y, pixelOffSet } = this.props.chamberRows[manifold.initialRow],
          rowSpacing = this.getRowSpacing(),
          chamberWidth = this.getChamberWidth(),
          chamberHeight = this.getChamberHeight(),
          endcapWidth = this.getEndCapWidth(),
          endcapHeight = this.getEndCapHeight(),
          chamberInstalledOffset = this.getEndcapInstalledOffset(),
          endcapInstalledOffset = this.getEndcapInstalledOffset(),
          activeChamber = this.props.chamberRows[manifold.initialRow].chambers[manifold.letColumn];

        // FIXME: Not 100% accurate; the chamber bed is building without an offset on the bottom side for some chamber types.
        // FIXME: It throws off the calculation for those chamber types slightly.
        const realX =
            x +
            activeChamber.x +
            pixelOffSet +
            chamberWidth +
            endcapWidth -
            chamberInstalledOffset -
            endcapInstalledOffset,
          realY = y + activeChamber.y;

        return (
          <Group key={idx} scaleX={-1} x={realX} y={realY}>
            <Manifold
              x={0}
              y={0}
              manifold={manifold}
              chamberWidth={chamberWidth}
              chamberHeight={chamberHeight}
              endcapWidth={endcapWidth}
              endcapHeight={endcapHeight}
              chamberInstalledOffset={chamberInstalledOffset}
              endcapInstalledOffset={endcapInstalledOffset}
              rowSpacing={rowSpacing}
              chamberColumn={activeChamber.col}
            />
          </Group>
        );
      } catch (exception) {
        return null;
      }
    });
  }

  renderChamberRows() {
    let rowSelectionOffset = 0;
    if (this.props.stonebedPoints.length) {
      rowSelectionOffset = this.props.stonebedPoints
        .reduce((result, value, index, array) => {
          if (index % 2 === 0) {
            result.push(array.slice(index, index + 2));
          }

          return result;
        }, [])
        .map((pair) => pair[0] + 5 + this.getEndCapHeight() / 2.5)
        .reduce((last, x) => Math.max(isNaN(x) ? 0 : x, last), 0);
    }

    let selectedRow = -1;
    // set the selected row if any
    if (
      this.props.contextSelectedElement &&
      this.props.contextSelectedElement.type === CONTEXT_SELECTED_ELEMENT_TYPE_CHAMBER_ROW
    ) {
      selectedRow = this.props.contextSelectedElement.row;
    }

    return this.props.chamberRows.map((chamberRow, index) => {
      return (
        <ChamberRowView
          key={index}
          row={chamberRow.row}
          x={chamberRow.x + chamberRow.pixelOffSet}
          y={chamberRow.y}
          rowSpacing={this.getRowSpacing()}
          height={chamberRow.height}
          width={chamberRow.width}
          chamberWidth={chamberRow.chamberWidth}
          endCapHeight={chamberRow.endCapHeight}
          endCapWidth={chamberRow.endCapWidth}
          endcapInstalledOffset={chamberRow.endcapInstalledOffset}
          chamberInstalledOffset={chamberRow.chamberInstalledOffset}
          offSet={chamberRow.offSet}
          chambers={chamberRow.chambers}
          isSelected={selectedRow === chamberRow.row}
          rowSelectionOffset={rowSelectionOffset}
        />
      );
    });
  }

  /**
   * Draws the yellow circle that helps determining the Bed Center Point
   */
  drawBedCenterPoint() {
    return (
      <Circle
        id="chamberBedCenterPoint"
        x={(this.props.height * this.props.scaleX) / 2}
        y={(this.props.width * this.props.scaleY) / 2}
        radius={10}
        fill="yellow"
        stroke={'black'}
        strokeWidth={1}
        visible={this.props.enableDebuging}
      />
    );
  }

  render() {
    let triangleOffset = this.props.getScaledValue(-6);
    const triangleRadius = this.props.getScaledValue(4);
    const triangleStrokeWidth = this.props.getScaledValue(0.4);
    if (this.props.stonebedPoints.length) {
      triangleOffset += this.props.stonebedPoints
        .reduce((result, value, index, array) => {
          if (index % 2 === 0) {
            result.push(array.slice(index, index + 2));
          }

          return result;
        }, [])
        .map((pair) => pair[0])
        .reduce((last, x) => Math.min(isNaN(x) ? 0 : x, last), 0);
    }
    const sizeLiner = this.props.imperviousLiner ? 1 : 1;
    return (
      <Layer visible={true}>
        {/* This groups the front triangle handler and invokes the transformation on clicks */}
        <Group
          id="chamberBed"
          x={this.props.x}
          y={this.props.y}
          height={this.props.height}
          width={this.props.width}
          rotation={this.props.rotation}
          onDragMove={() => this.handleFrontDragMove()}
          onDragEnd={() => this.handleFrontDragEnd()}
          onClick={() => this.handleBedOnclick()}
          draggable={true}
          ref={(node) => {
            this.frontGroupNode = node;
          }}>
          {/* This is the Front pointing arrow of the chamber bed */}
          <RegularPolygon
            x={triangleOffset}
            y={(this.props.height * this.props.scaleY) / 2}
            rotation={-90}
            sides={3}
            radius={triangleRadius}
            fill={this.props.drawingSelectorMode === GLOBAL_DRAWING_SELECTOR_MODE_DIRECT ? 'orange' : '#0C92CD'}
            stroke={'black'}
            strokeWidth={triangleStrokeWidth}
            opacity={0.7}
            onMouseEnter={() => this.handleOnMouseEnter()}
            onMouseLeave={() => this.handleOnMouseLeave()}
            ref={(node) => {
              this.frontArrowNode = node;
            }}
          />
        </Group>
        {/* This is the bed rectangle grey dotted line */}
        <Rect
          x={this.props.x}
          y={this.props.y}
          scaleX={this.props.scaleX}
          scaleY={this.props.scaleY}
          height={this.props.height}
          width={this.props.width}
          rotation={this.props.rotation}
          ref={(node) => {
            this.borderNode = node;
          }}
          /* note: this was removed to prevent the dragging of the bed
          as we expand, changes will be done at render time only */
          // onTransform={() => this.handleOnTransform()}
          onTransformEnd={() => this.handleOnTransformEnd(...arguments)}
          stroke={this.isContextSelected() ? 'orange' : '#79a9ce'}
          // strokeWidth={this.isContextSelected() ? sizeLiner + 2 : sizeLiner}
          strokeWidth={this.isContextSelected() ? 2 : 1}
          dash={[6, 6]}
        />
        {/* This is the group containing all chamber rows, note that must be at the end
                 of the nodes in this layer to be in top position and listen to events. */}
        <Group
          x={this.props.x}
          y={this.props.y}
          height={this.props.height * this.props.scaleY}
          width={this.props.width * this.props.scaleX}
          rotation={this.props.rotation}
          ref={(node) => {
            this.chamberGroupNode = node;
          }}>
          <Underdrain />
          {/* Render chamber rows in state */}
          {this.renderChamberRows()}
          {/* Render manifolds */}
          {this.renderUpperManifolds()}
          {this.renderLowerManifolds()}
          {/* Render center point when debugging */}
          {this.drawBedCenterPoint()}
        </Group>
      </Layer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    stonebedPoints: state.stonebed.points,
    x: state.chamberbed.x,
    y: state.chamberbed.y,
    scaleX: state.chamberbed.scaleX,
    scaleY: state.chamberbed.scaleY,
    rotation: state.chamberbed.rotation,
    height: state.chamberbed.height,
    width: state.chamberbed.width,
    visible: state.chamberbed.visible,
    chamberRows: state.chamberbed.chamberRows,
    selectedContextRow: state.chamberbed.selectedContextRow,
    numOfRows: state.chamberbed.numOfRows,
    numOfChambers: state.chamberbed.numOfChambers,
    /* these two metrics comes from global reducer */
    scalePixels: state.globals.scalePixels,
    scaleValue: state.globals.scaleValue,
    chamberType: state.globals.chamberType,
    chamberEndCapType: state.globals.chamberEndCapType,
    chamberRowSpacing: state.globals.chamberRowSpacing,
    contextSelectedElement: state.globals.contextSelectedElement,
    pressedKeys: state.globals.pressedKeys,
    /* computed height and width from viewport */
    viewportPositionX: state.viewport.positionX,
    viewportPositionY: state.viewport.positionY,
    isPanning: state.viewport.isPanning,
    computedHeight: state.viewport.computedHeight,
    computeWidth: state.viewport.computeWidth,
    enableDebuging: state.globals.enableDebuging,

    upperManifolds: ManifoldSelectors.getManifoldsByType('upper'),
    lowerManifolds: ManifoldSelectors.getManifoldsByType('lower'),
    mainManifolds: state.mainManifolds.manifolds,
    mainMainManifolds: state.mainManifolds,
    structureDistance: state.calculations.structureDistance,
    manifoldSize: state.calculations.manifoldSize,
    structureSize: state.calculations.structureSize,
    manifoldStructures: state.stonebed.manifoldStructures,
    manifoldSeparation: state.calculations.manifoldSeparation,
    manifoldSeparationRound: state.calculations.manifoldSeparation.round,
    manifoldSeparationSquare: state.calculations.manifoldSeparation.square,
    manifoldSeparationNyloplast: state.calculations.manifoldSeparation.nyloplast,
    sepDistance: state.stonebed.sepDistance,
    isDirty: state.chamberbed.isDirty,
    drawingSelectorMode: state.globals.drawingSelectorMode,
    /* this flag tells us a project is being loaded from manage projects */
    isRestoringState: state.globals.isRestoringState,

    updatePerimeterOnBed: state.multiBed.updatePerimeterOnBed,
    chamberRowSpacingPixels: state.globals.chamberRowSpacingPixels,
    underdrain: state.calculations.underdrain,
    manifoldSeparations: state.calculations.manifoldSeparations,

    imperviousLiner: state.chamberbed.imperviousLiner,

    chamberbed: state.chamberbed,
  };
};

const mapDispatchToProps = {
  getScaledValue,
  chamberBedMoved,
  chamberBedTransformed,
  chamberRowsRebuild,
  chamberBedContextSelected,
  chamberBedSetCentralizedCoordinates,
  restoredStateBedRendered,
  cleanChambersByManifoldVoidArray,
  cleanChambersByManifoldMainRowArray,
  setUpdatePerimeterOnBed,
  computeStoneBed,
  setChamberAccesory,
  getChamberAccessoryMap,
  updateNumberOfFeedConnectors,
  updatePositionOfInspectionPort
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChamberBed);



// WEBPACK FOOTER //
// ./src/components/Drawings/chamber-bed.js